import * as React from "react";
import { AlertTriangle } from "react-feather";
import { humanize } from "../../../dateString";
import { useAppSelector } from "../../../../store/hooks";

export const AdminPanelSession: React.FC = () => {
  const expires = useAppSelector((state) => state.user.expires);
  const type = useAppSelector((state) => state.user.type);
  const org = useAppSelector((state) => state.user.org);
  const email = useAppSelector((state) => state.user.email);

  const [count, setCount] = React.useState(0);

  React.useEffect(() => {
    const id = setInterval(() => setCount((x) => x + 1), 1000);
    return () => {
      clearInterval(id);
    };
  }, [type]);

  const expiresMs = expires * 1000;
  const diff = new Date().getTime() - expiresMs;
  const isExpired = diff > 0;

  return (
    <div className="px-4 py-1 rounded bg-color-danger flex items-center gap-2" style={{ color: "var(--color-white)" }}>
      <div className="absolute invisible">{count}</div>
      <AlertTriangle />
      <div className="flex flex-col text-sm leading-tight">
        <span>{type === "inspect" ? `Inspecting Org: ${org}` : `Impersonating User: ${email}`}</span>
        {isExpired ? <span>Session Expired</span> : <span>Session Expires In: {humanize(expiresMs)}</span>}
      </div>
    </div>
  );
};
